import { useState } from 'react';

import { partition } from 'lodash';
import { Plus } from 'lucide-react';
import { Button, ProgressMulti, Box, Label } from 'twyne-new.ui'

import Form from './Form';
import Item from './Item';

export default function List({ data, options, onChange }) {
  const total = data?.reduce((total, offer) => total + Number(offer.weight), 0)

  const reorder = offers => {
    const [activated, disabled] = partition(offers, offer => offer)
    return [...activated, ...disabled]
  }

  const handleAdd = offer => {
    const active = data?.filter(offer => offer.id) || []
    active.push(offer)
    const update = reorder(active)
    onChange(update)
  }

  const handleRemove = index => {
    data.splice(index, 1)
    onChange([...data])
  }

  const handleChange = (index, values) => {
    data[index] = values
    const update = reorder(data)
    onChange(update)
  }

  return <>
    <div className='flex items-center justify-between'>
      <Label>Offers</Label>
      <Add options={options} onAdd={handleAdd} />
    </div>
    <Box>
      <ProgressMulti fadeColor>
        {data?.map((item, index) => <Item
          key={index}
          index={index}
          data={item}
          options={options}
          onChange={handleChange}
          onRemove={handleRemove}
          total={total}
        />)}
      </ProgressMulti>
    </Box>
  </>
}

function Add({ options, onAdd }) {
  const [toggle, setToggle] = useState(false)

  return <div>
    <Button className="float-right" size="sm" color='accent' onClick={() => setToggle(!toggle)}>
      <Plus size={14} />
      Add
    </Button>
    <Form
      options={options}
      onAdd={onAdd}
      toggle={toggle}
      setToggle={setToggle}
    />
  </div>
}
